export enum BaseCoins {
  ETHEREUM = "ETHEREUM",
  BITCOIN = "BITCOIN",
  SOLANA = "SOLANA",
}

export enum TargetCoins {
  USD = "USD",
  EUR = "EUR",
  GBP = "GBP",
}
